import axios from '@/axios/axios'

export default {
    namespaced: true, 
    actions:{
        requestAddressList(){
            return axios
            .get('/api/address/getList')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.log(error)
                return Promise.reject(error)
            })
        },
        requestAddressDetailList(context, admCode){
            return axios
            .get('/api/address/getDetailList', {
                params: {
                    admCode: admCode
                }
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.log(error)
                return Promise.reject(error)
            })
        }
    }
}